import { VStack, Stack, Text, Button } from "@chakra-ui/react";
import { useRouter } from "next/router";
import type { FormStepProps } from "../../interfaces";
import BillingAddress from "./BillingAddress";
import SubscriptionPrices from "./SubscriptionPrices";
import Link from "next/link";
import { getPaths } from "lib/utils/paths";
import { useTranslations } from "next-intl";
import { INPUT_SPACING } from "pages/Register/RegisterPage";

const StepFive = ({
  onSubmit,
  RegisterMutationResult,
  goBack,
  disabled,
  FormController,
}: FormStepProps) => {
  const { query } = useRouter();
  const t = useTranslations("pages.register");

  return (
    <VStack
      spacing={INPUT_SPACING}
      w="full"
      maxW={["full", "full", "full", "1400px"]}
      mt="12"
    >
      <Stack
        w="full"
        spacing="16"
        direction={["column", "column", "column", "row"]}
      >
        <BillingAddress
          FormController={FormController}
          disabled={!!disabled}
        />
        <SubscriptionPrices
          FormController={FormController}
          selectedPlan={FormController.watch("plan_id")}
        />
      </Stack>

      <VStack spacing={5} align="center" w="full" mt="12">
        {query.success === "false" ? (
          <Text fontSize="lg" textAlign="center">
            {t("finalStepAthleRegistrationContent5")}
            <br /> {t("finalStepAthleRegistrationContent6")}
          </Text>
        ) : RegisterMutationResult?.error && (
          <VStack>
            <Text color="red.500">{RegisterMutationResult?.error.message}</Text>
            {RegisterMutationResult?.error.message?.includes("registado") && (
              <Link href={getPaths.login()}>{t("signInMessage")}</Link>
            )}
          </VStack>
        )}
        <Button
          isLoading={RegisterMutationResult?.loading}
          colorScheme="brandOrange"
          onClick={FormController.handleSubmit(onSubmit)}
          loadingText={t("nextAthleteButton4")}
        >
          {t("nextAthleteButton4")}
        </Button>
        {!disabled && (
          <Button colorScheme="gray" variant="link" onClick={goBack}>
            {t("backAthleteButton4")}
          </Button>
        )}
      </VStack>
    </VStack >
  );
};

export default StepFive;
